import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { tap } from 'rxjs/operators';
import { InitAuthService } from '@app/services/global-services/auth/init-auth-service';
import { environment } from '@src/environments/environment';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const initAuthService: InitAuthService = inject(InitAuthService);
  const b2bDeviceUtilService: B2bDeviceUtilService =
    inject(B2bDeviceUtilService);

  if (b2bDeviceUtilService?.isServer()) {
    return true;
  }

  const router: Router = inject(Router);

  return initAuthService.isAuthenticated().pipe(
    tap((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        if (environment.webApp) {
          if (b2bDeviceUtilService?.isDesktop()) {
            router.navigateByUrl('/').then();
          } else {
            router.navigateByUrl('/auth/login').then();
          }
        } else {
          router.navigateByUrl('/auth/login').then();
        }
      }
    }),
  );
};
